import React, { useState } from "react";
import "../../style/NavMenu.css";

/**
 * Props:
 * - navItems: [{ label, icon }]
 * - step: number (current step, 1-based)
 * - setStep: fn
 * - formattedDate: truthy/falsy (used for disabling items except first)
 * - iconsBasePath: optional base path for icons
 */
export default function NavMenu({
  navItems = [],
  step = 1,
  setStep = () => {},
  formattedDate,
  iconsBasePath = "/wp-content/themes/hello-elementor-child/react-app/images/navigation/",
}) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSelect = (index, shouldFade) => {
    console.log("handleSelect called with index:", index, "shouldFade:", shouldFade);
    if (shouldFade) return;
    setStep(index + 1);
    setMenuOpen(false);
  };

  return (
    <>
      {/* Mobile topbar (visible on small screens) */}
      <div className="nav-topbar">
        <button
          className={`hamburger ${menuOpen ? "open" : ""}`}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((s) => !s)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Desktop sidebar (keeps your existing classes) */}
      <div className={`side-bar desktop-only`} role="navigation" aria-label="Steps navigation">
        {navItems.map((item, index) => {
          const shouldFade = index !== 0 && !formattedDate;
          const isSelected = step === index + 1;
          return (
            <div
              className={`nav-item ${shouldFade ? "fade-icon" : ""} ${isSelected ? "selected" : ""}`}
              key={index}
              onClick={() => !shouldFade && setStep(index + 1)}
              role="button"
              aria-disabled={shouldFade}
              tabIndex={shouldFade ? -1 : 0}
              onKeyDown={(e) => {
                if ((e.key === "Enter" || e.key === " ") && !shouldFade) setStep(index + 1);
              }}
            >
              <img
                src={`${iconsBasePath}${item.icon}.svg`}
                alt={item.label}
                className="nav-icon"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = `/images/navigation/${item.icon}.svg`;
                }}
              />
              <div className="nav-label">{item.label}</div>
            </div>
          );
        })}
      </div>

     {/* Mobile slide-in menu */}
        <div className={`mobile-menu ${menuOpen ? "open" : ""}`} aria-hidden={!menuOpen}>
        <div className="mobile-menu-inner">
            {/* Close button */}
           {/*  <button
            className="mobile-menu-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
            >
            &times;
            </button>
 */}
            {navItems.map((item, index) => {
            const shouldFade = index !== 0 && !formattedDate;
            const isSelected = step === index + 1;
            return (
                <div
                key={index}
                className={`nav-item mobile-only-item ${shouldFade ? "fade-icon" : ""} ${isSelected ? "selected" : ""}`}
                onClick={() => handleSelect(index, shouldFade)}
                role="button"
                aria-disabled={shouldFade}
                >
                <img
                    src={`${iconsBasePath}${item.icon}.svg`}
                    alt={item.label}
                    className="nav-icon"
                    onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = `/images/navigation/${item.icon}.svg`;
                    }}
                />
                <div className="nav-label">{item.label}</div>
                </div>
            );
            })}
        </div>

        {/* backdrop */}
        <div className="mobile-menu-backdrop" onClick={() => setMenuOpen(false)} />
        </div>

    </>
  );
}
